/**
 * The shape a sectioned shell navigates by: destinations in named groups, each
 * with what the sidebar and the phone index both need to draw it.
 */import*as React from"react";// A group a shell draws itself after the destination groups, for rows that
// are not destinations, such as an action: its heading, and its rows as
// `li` elements drawn in the manner of the drawing that holds them.
/**
 * The destination a pathname belongs to: the one whose path it is, or the
 * one whose path it sits under (`/internal/jobs/schedule` belongs to
 * `/internal/jobs`); null for a pathname that is none of them.
 */export function destinationFor(groups,pathname){for(const group of groups){for(const destination of group.destinations){if(pathname===destination.path||pathname.startsWith("".concat(destination.path,"/"))){return destination;}}}return null;}